import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { addActivity } from "../store/slices/activity";
import { nameregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import { GrUploadOption } from "react-icons/gr";

const AddActivities = () => {
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [activityDate, setactivityDate] = useState("");
  const [image, setImage] = useState([]);
  const [imageError, setImageError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [visibility, setVisibility] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  /** IMAGE UPLOAD **/
  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (image.length + files.length > 10) {
      setImageError("You can upload a maximum 10 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 10 * 1024 * 1024) {
        setImageError("Please upload image less than 10 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.upload}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImage((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  const removeImage = (index) => {
    setImage((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      setName(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        name:
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid place name"
            : "",
      }));
    }

    if (name === "activityDate") {
      setactivityDate(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        activityDate: value.trim() === "" ? "Please enter a activity date" : "",
      }));
    }

    if (name === "description") {
      setDescription(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        description:
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid description"
            : "",
      }));
    }
  };

  const addactivi = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const validationErrors = {};

    if (!name.trim()) {
      validationErrors.name = "Please enter place name";
    } else if (!nameregex.test(name)) {
      validationErrors.name = "Name must be at least three characters";
    }

    if (!activityDate.trim()) {
      validationErrors.activityDate = "Please enter activity date";
    }

    if (!description.trim() || description.length === 0) {
      validationErrors.description = "Please enter valid description";
    }

    if (image.length === 0) {
      setImageError("Please upload at least one image");
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const item = {
      name,
      description,
      image,
      activityDate,
    };

    try {
      await dispatch(addActivity(item)).unwrap();
      navigate("/admin/activity");
      alert("Activity added successfully!");
    } catch (error) {
      alert(error);
    }
  };

  const cancel = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Activity</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/activity"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Activity
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Activity</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={addactivi}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Activity Name"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="activityDate"
                  value={activityDate}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.activityDate ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Activity Date"
                />
                {errors.activityDate && (
                  <div className="text-danger mt-2">{errors.activityDate}</div>
                )}
              </div>

              <div className="col-md-10 mt-2">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {image.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <textarea
                  className="form-control"
                  value={description}
                  name="description"
                  onChange={handleChange}
                />
                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddActivities;
